export default __webpack_public_path__ + "static/media/Binger3.92eb0eda.png";